module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"choose":"Choose job","fromVacancy":"From job","copy":"Choose job to copy questions from","copyBtn":"Copy questions from another job"}}')
  delete Component.options._Ctor
}
